<template>
  <div>
    <header class="d-flex align-items-center justify-content-between mb-3">
      <h5 class="m-0">Latest Detections</h5>

      <p v-if="loading" class="x-small text-muted m-0">
        Loading...
      </p>
    </header>

    <div class="detections-grid-container">
      <div class="detections-grid-header species-latest-detections-row" ref="header">
        <div>Time<span class="d-none d-sm-inline">stamp</span></div>
        <div>Station</div>
        <div class="text-center">Score</div>
      </div>

      <RecycleScroller ref="scroller" class="detections-grid" :items="detections || []" :item-size="rowHeight">
        <template v-slot="{ item }">
          <LatestDetectionRow :key="item.id" :detection="item" />
        </template>
      </RecycleScroller>
    </div>
  </div>
</template>

<script>
import LatestDetectionRow from './LatestDetectionRow'

import { RecycleScroller } from 'vue-virtual-scroller'

export default {
  props: {
    detections: {
      type: Array
    },

    loading: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    rowHeight () {
      return window.outerWidth >= 1200 ? 40 : 45
    }
  },

  components: {
    LatestDetectionRow,
    RecycleScroller
  }
}
</script>
